export const filterByStatus = (filter) => {
 return (book) => {
  switch (filter.status) {
   case "Featured":
    return book.featured === true;
   default:
    return true;
  }
 };
};
export const filterBySearchValue = (filter) => {
 return (book) => {
  return book?.name?.toLowerCase().includes(filter.search?.toLowerCase());
 };
};
